import {pushNoInteractionTagManagerChatbot} from './tagManager';

export const startAddresseFromBureauFlow = () => {
  return [
    {
      text: 'Encontrei esse endereço vinculado ao seu CNPJ:',
      type: 'message-receive'
    },
    {
      type: 'start-addresses-flow',
      index: 0,
      step: 'address'
    }
  ];
};

export const inputAddressWithoutInfoBureau = () => {
  pushNoInteractionTagManagerChatbot({
    elementContent: 'step-15:none:cep'
  });
  return {
    text: `Agora, me informe o CEP do endereço que está atrelado ao seu CNPJ, por favor!`,
    responseType: 'address-zipcode-without-info-bureau-input',
    type: 'message-receive-address-icon',
    index: 0,
    step: 'address'
  };
};

//Contrato das apis que retornam endereços baseado no cep
export const validateAddressFromPlacesApi = (
  addressState,
  addressFromApi,
  type
) => {
  let addressToUpdateReducer = [...addressState];
  const na = 'Não consta informação';
  let zipCodeFormated = addressFromApi.cep.replace(/-/g, '');
  let address = {
    zipCode: zipCodeFormated || na,
    address: addressFromApi.streetName || na,
    number: addressFromApi.number || na,
    complement: addressFromApi.complement || na,
    city: addressFromApi.cityName || na,
    neighborhood: addressFromApi.districtName || na,
    state: addressFromApi.uf || na,
    types: [type]
  };
  addressToUpdateReducer.push(address);

  return addressToUpdateReducer;
};

export const validateAddressFromPlacesApiAlternative = (
  addressState,
  addressFromApi,
  type
) => {
  let addressToUpdateReducer = [...addressState];
  const na = 'Não consta informação';
  let zipCodeFormated = addressFromApi.cep.replace(/-/g, '');
  let address = {
    zipCode: zipCodeFormated || na,
    address: addressFromApi.logradouro || na,
    number: addressFromApi.number || na,
    complement: addressFromApi.complemento || na,
    city: addressFromApi.localidade || na,
    neighborhood: addressFromApi.bairro || na,
    state: addressFromApi.uf || na,
    types: [type]
  };
  addressToUpdateReducer.push(address);

  return addressToUpdateReducer;
};

export const validateAddressFromPlacesApiAlternative2 = (
  addressState,
  addressFromApi,
  type
) => {
  let addressToUpdateReducer = [...addressState];
  const na = 'Não consta informação';
  let zipCodeFormated = addressFromApi.code.replace(/-/g, '');
  let address = {
    zipCode: zipCodeFormated || na,
    address: addressFromApi.address || na,
    number: addressFromApi.number || na,
    complement: addressFromApi.complemento || na,
    city: addressFromApi.city || na,
    neighborhood: addressFromApi.district || na,
    state: addressFromApi.state || na,
    types: [type]
  };
  addressToUpdateReducer.push(address);

  return addressToUpdateReducer;
};

export const validateAddressFromPlacesApiAlternative3 = (
  addressState,
  addressFromApi,
  type
) => {
  let addressToUpdateReducer = [...addressState];
  const na = 'Não consta informação';
  let zipCodeFormated = addressFromApi.cep.replace(/-/g, '');
  let address = {
    zipCode: zipCodeFormated || na,
    address: addressFromApi.logradouro || na,
    number: addressFromApi.number || na,
    complement: addressFromApi.complemento || na,
    city: addressFromApi.cidade || na,
    neighborhood: addressFromApi.bairro || na,
    state: addressFromApi.estado || na,
    types: [type]
  };
  addressToUpdateReducer.push(address);

  return addressToUpdateReducer;
};
// Fim dos contratos das apis que retornam endereços pelo cep
export const addEmptyAttributesAddressObject = () => {
  return {
    zipCode: '',
    address: '',
    number: '',
    complement: '',
    city: '',
    neighborhood: '',
    state: '',
    types: ['PADRAO']
  };
};

export const validateJson = (ArrayaddressesFromServerSide) => {
  let validatedAddressObjectStructure = ArrayaddressesFromServerSide;

  let addressKeys = [
    'zipCode',
    'address',
    'number',
    'complement',
    'city',
    'neighborhood',
    'state',
    'types'
  ];

  for (let i = 0; i < validatedAddressObjectStructure.length; i++) {
    for (let key in addressKeys) {
      if (validatedAddressObjectStructure[i][addressKeys[key]] === undefined) {
        if (addressKeys[key] === 'types') {
          Object.assign(validatedAddressObjectStructure[i], {
            [addressKeys[key]]: ['PADRAO']
          });
        } else {
          Object.assign(validatedAddressObjectStructure[i], {
            [addressKeys[key]]: ''
          });
        }
      }
    }
  }
  return validatedAddressObjectStructure;
};

export const updateNumberOfAddress = (index, userMessage, ecAddresses) => {
  return ecAddresses.map((address, idx) => {
    if (idx === index) {
      return {
        ...address,
        number: userMessage
      };
    }
    return address;
  });
};

export const updateComplementOfAddress = (index, userMessage, ecAddresses) => {
  return ecAddresses.map((address, idx) => {
    if (idx === index) {
      return {
        ...address,
        complement: userMessage
      };
    }
    return address;
  });
};

export const updateCityOfAddress = (index, userMessage, ecAddresses) => {
  return ecAddresses.map((address, idx) => {
    if (idx === index) {
      return {
        ...address,
        city: userMessage
      };
    }
    return address;
  });
};

export const updateAddressOfAddress = (index, userMessage, ecAddresses) => {
  return ecAddresses.map((address, idx) => {
    if (idx === index) {
      return {
        ...address,
        address: userMessage
      };
    }
    return address;
  });
};

export const updateStateOfAddress = (index, userMessage, ecAddresses) => {
  return ecAddresses.map((address, idx) => {
    if (idx === index) {
      return {
        ...address,
        state: userMessage
      };
    }
    return address;
  });
};

export const updateNeighborhoodOfAddress = (
  index,
  userMessage,
  ecAddresses
) => {
  return ecAddresses.map((address, idx) => {
    if (idx === index) {
      return {
        ...address,
        neighborhood: userMessage
      };
    }
    return address;
  });
};

export const updateZipCodeOfAddress = (index, userMessage, ecAddresses) => {
  return ecAddresses.map((address, idx) => {
    if (idx === index) {
      return {
        ...address,
        zipcode: userMessage
      };
    }
    return address;
  });
};

export const addTypeToAddressFromBureau = (types, index) => {
  index = index + 1;
  if (types.includes('PADRAO') || types.length === 0) {
    let message = {
      text: 'Por favor, selecione de onde é esse endereço:',
      type: 'message-receive-address-type',
      responseType: 'disabled',
      index: index,
      step: 'address'
    };
    return message;
  } else if (types.includes('LOJA') && types.includes('CORRESPONDENCIA')) {
    let message = {
      send: 'sendToServerSide',
      index: index
    };
    return message;
  } else if (!types.includes('CORRESPONDENCIA')) {
    let message = {
      text: `Também vou precisar de um endereço que está cadastrado na Receita Federal. Digite o CEP para eu localizar, por favor!`,
      responseType: 'address-zipcode-correspondencia-from-api-input',
      type: 'message-receive',
      index: index,
      step: 'address'
    };

    return message;
  } else if (!types.includes('LOJA')) {
    let message = {
      text: `Agora, conta para mim qual é o endereço da sua loja. Para começar, digite o CEP.`,
      responseType: 'address-zipcode-loja-from-api-input',
      type: 'message-receive',
      index: index,
      step: 'address'
    };
    return message;
  }
};

const addressesQuestions = (ec, index) => {
  const na = 'Não consta informação';
  const address = ec.addresses[index];
  let message = {};
  if (address.address === na || address.address === '') {
    message = {
      index: index,
      text: `Por favor digite a Rua`,
      responseType: 'address-address-from-api-input',
      type: 'message-receive',
      step: 'address'
    };
  } else if (
    (address.number === na || address.number === '') &&
    address.number !== undefined
  ) {
    message = {
      index: index,
      text: `Pode me informar qual é o número?`,
      responseType: 'address-number-from-api-input',
      type: 'message-receive',
      step: 'address'
    };
  } else if (address.complement === na || address.complement === '') {
    message = {
      index: index,
      text: 'O endereço possui complemento?',
      type: 'address-from-bureau-complement-confirm',
      step: 'address'
    };
  } else if (address.neighborhood === na || address.neighborhood === '') {
    message = {
      index: index,
      text: `Por favor digite o Bairro`,
      responseType: 'address-neighborhood-from-api-input',
      type: 'message-receive',
      step: 'address'
    };
  } else if (address.city === na || address.city === '') {
    message = {
      index: index,
      text: `Por favor digite a cidade`,
      responseType: 'address-city-from-api-input',
      type: 'message-receive',
      step: 'address'
    };
  } else if (address.state === na || address.state === '') {
    message = {
      index: index,
      text: `Por favor digite o Estado /  Distrito`,
      responseType: 'address-state-from-api-input',
      type: 'message-receive',
      step: 'address'
    };
  } else if (address.zipCode === na || address.zipCode === '') {
    message = {
      text: `Por favor digite CEP`,
      type: 'message-receive',
      responseType: 'address-zipcode-input',
      index: index,
      step: 'address'
    };
  }
  return message;
};

export const checkPropertiesAddressFromAPI = (ecState, index) => {
  let addressToVerify = ecState.addresses[index];
  const na = 'Não consta informação';
  let count = 0;
  for (let key in addressToVerify) {
    if (addressToVerify[key] === na || addressToVerify[key] === '') {
      count++;
    }
  }
  if (count > 0) {
    let message = addressesQuestions(ecState, index);
    return message;
  } else if (index === 0) {
    return {
      text: 'Por favor, selecione de onde é esse endereço:',
      type: 'message-receive-address-type',
      responseType: 'disabled',
      index: index,
      step: 'address'
    };
  } else {
    const types = [];
    for (let address of ecState.addresses) {
      types.push(...address.types);
    }

    return addTypeToAddressFromBureau(types, index);
  }
};

export const userMessageAddressesHandler = (userMessage, index) => {
  return {
    text: userMessage,
    type: 'response-sent',
    step: 'address',
    index: index
  };
};
